import { Link } from 'react-router-dom';
import { Eye, Heart } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { ListingStatusBadge } from '../ListingStatusBadge';
import { getCategoryName } from '../../utils/categoryNames';
import { ListingCardActions } from './ListingCardActions';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ListingCardList = ({ listing, price, stats, onDeleteClick, onRestore, onRenew, onPromote }) => {
  const { t } = useTranslation();
  const isDeleted = listing.status === 'deleted';
  const dateStr = listing.created_at ? new Date(listing.created_at).toLocaleDateString() : '';
  return (
    <div className={`bg-white border border-border rounded-lg p-3 flex flex-col sm:flex-row sm:items-center gap-3 ${isDeleted ? 'opacity-60' : ''}`} data-testid={`my-listing-row-${listing.listing_id}`}>
      <Link to={`/listings/${listing.listing_id}`} className={`flex items-center gap-3 flex-1 min-w-0 ${isDeleted ? 'pointer-events-none' : ''}`}>
        <div className="w-16 h-16 shrink-0 rounded-md bg-surface overflow-hidden">
          {listing.images?.length > 0 ? (
            <img src={`${API}/files/${listing.images[0]}`} alt={listing.title} className="w-full h-full object-cover" />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-text_muted text-[10px]">{t('common.noImage')}</div>
          )}
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 flex-wrap">
            <h3 className="font-semibold text-sm truncate" data-testid="listing-title">{listing.title}</h3>
            <ListingStatusBadge listing={listing} showActive />
          </div>
          <p className="text-xs text-text_muted truncate">{getCategoryName(listing.category, t)}{listing.city ? ` · ${listing.city}` : ''}</p>
          <div className="flex items-center gap-3 text-[11px] text-text_muted mt-0.5 flex-wrap">
            <span className="font-bold text-primary text-sm" data-testid="listing-price">{price}</span>
            <span className="flex items-center gap-1"><Eye size={11} /> {listing.view_count || 0}</span>
            <span className="flex items-center gap-1"><Heart size={11} /> {stats.favorites_count || 0}</span>
            <span>{dateStr}</span>
          </div>
        </div>
      </Link>
      <div className="w-full sm:w-auto sm:min-w-[220px]">
        <ListingCardActions listing={listing} onDeleteClick={onDeleteClick} onRestore={onRestore} onRenew={onRenew} onPromote={onPromote} />
      </div>
    </div>
  );
};
